module.exports = __webpack_public_path__ + "img/prince's_knife.b546015f.png";